import React, {useState} from "react";

// Contenu d'un badge d'avatar : l'illustration de l'animal quand elle existe, sinon l'emoji.
// À placer dans le cercle coloré (styles.avatarCircle) ; l'emoji reste le repli si l'image ne charge pas.
export default function AvatarBadge({avatar, size}) {
    const [failed, setFailed] = useState(false);
    if (!avatar.image || failed) return <>{avatar.avatar}</>;
    return (
        <img
            src={avatar.image}
            alt=""
            loading="lazy"
            onError={() => setFailed(true)}
            style={{width: size || "100%", height: size || "100%", borderRadius: "50%", objectFit: "cover", display: size ? "inline-block" : "block", verticalAlign: "middle"}}
        />
    );
}
